module.exports = __webpack_public_path__ + "img/icon-custom.6caa80a4.png";